import { useEffect, useState } from "react";
import styles from "./Portfolio.module.css";
import client from "../../config/contentful";
import SimpleSlider from "../../Components/Slider/Slider";
import Page from "../../Components/Page/Page";

function Portfolio() {
  const [content, setContent] = useState([]);

  useEffect(() => {
    client
      .getEntries({
        content_type: "projectPage",
      })
      .then((response) => {
        setContent(response.items[0].fields.projects);
      })
      .catch((error) => console.error(error));
  }, []);

  return (
    <Page>
      <div className={styles.content}>
        <h1 className={styles.title}>Portfolio</h1>
        {content.map((project, projectIndex) => (
          <div key={projectIndex}>
            <div className={styles.subtitle}>{project.fields.title}</div>
            <div className={styles.tag}>{project.fields.subtitle}</div>
            <div className={styles.imageContainer}>
              <SimpleSlider
                images={project.fields.images.map(
                  (asset) => `https:${asset.fields.file.url}`
                )}
              />
            </div>
          </div>
        ))}
      </div>
    </Page>
  );
}

export default Portfolio;
